// extracted by mini-css-extract-plugin
module.exports = {"spinner":"base__spinner___Csj0o","pageScroll":"base__pageScroll___1dJa6","pageNoScroll":"base__pageNoScroll___31Dow","scrollbarMinWidth":"base__scrollbarMinWidth___1PoZz"};